module.exports = __webpack_public_path__ + "img/genre6.8cf95d38.svg";